import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SideNavItemExternal = ({ iconClassName = '', text = '', onClick = () => { }, disabled = false, link = '', labelNewUntil = new Date(), iconName = '' }) => {
  const onClickHandler = (e) => {
    if (!disabled) {
      onClick(e);
    }
  };

  const now = new Date();
  const displayNewLabel = now.getTime() < labelNewUntil.getTime();

  const sideNavItemClass = classNames({
    'side-nav-item': true,
    'side-nav-item--new': displayNewLabel
  });

  return (
    <a
      className={sideNavItemClass}
      target="_blank"
      href={link}
      rel="noopener noreferrer"
      onClick={onClickHandler}
      data-test-id="side-nav-item-external"
    >
      {!iconName && <span className={`side-nav-item__icon ${iconClassName}`} />}
      {iconName && <span className="side-nav-item__icon"><img src={`assets/icons/${iconName}.svg`} /></span>}
      <span className="side-nav-item__text">{text}</span>
    </a>
  );
};

SideNavItemExternal.propTypes = {
  disabled: PropTypes.bool,
  iconClassName: PropTypes.string,
  iconName: PropTypes.string,
  labelNewUntil: PropTypes.instanceOf(Date),
  link: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default SideNavItemExternal;
